import { render, staticRenderFns } from "./PurgerTerms.vue?vue&type=template&id=724e6ee5&scoped=true&"
import script from "./PurgerTerms.vue?vue&type=script&lang=js&"
export * from "./PurgerTerms.vue?vue&type=script&lang=js&"
import style0 from "./PurgerTerms.vue?vue&type=style&index=0&id=724e6ee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e6ee5",
  null
  
)

export default component.exports